import { ComponentChildren, h } from 'preact';
import styled from 'styled-components';
import { backgroundColors } from '../../util/variables';

interface FormStepsProps {
	activeStep?: number;
	steps?: number;
	children?: ComponentChildren;
	stepCallbackOnClick?: any;
}

const FormStepsStyled = styled.div`
	align-items: center;
	align-content: center;
	display: flex;
	justify-content: center;
	width: 100%;
`;

const ActiveStep = styled.div``;

const Step = styled.div`
	background: ${backgroundColors.lightGreen};
	border-radius: 50%;
	height: 19px;
	margin: 0 14px;
	width: 19px;
`;

export const FormSteps = ({ activeStep = 1, steps = 1, children, stepCallbackOnClick }: FormStepsProps) => {
	return (
		<FormStepsStyled>
			{new Array(steps)
				.fill('')
				.map((step, idx) =>
					idx + 1 === activeStep ? <ActiveStep>{children}</ActiveStep> : <Step onClick={() => stepCallbackOnClick(idx + 1)} />,
				)}
		</FormStepsStyled>
	);
};
